import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'objToKeys',
  standalone: true
})

export class ObjToKeysPipe implements PipeTransform {
  public transform(value: any): any {
    if (!value) {
      return value;
    }
    return Object.keys(value);
  }
}
